<template>
  
  <div class="card pt-15">
    <div v-show="cadastro" class="card-body">
      <h4 class="card-title">Cadastro de Forma de Pagamento</h4>
      <button class="btn btn-info" @click="exibirLista" >Exibir Formas de Pagamento</button>
      <form class="m-t-40" v-on:submit.prevent="update(formaPagamento)">
        <div class="row col-md-8 col-12 pt-10">
          <div class="form-group col-md-6">
            <label>Descrição</label>
            <input type="text" class="form-control" placeholder="Obrigatório" required v-model="formaPagamento.descricao">
          </div>
          <div class="col-md-6">
            <label>Tipo Pagamento</label>
            <select class="form-control" required v-model="formaPagamento.tipo_nfce">
              <option value="1">Dinheiro</option>
              <option value="2">Cheque</option>
              <option value="3">Cartão de Crédito</option>
              <option value="4">Cartão de Débito</option>
              <option value="5">Crédito Loja</option>
              <option value="10">Vale Alimentação</option>
              <option value="11">Vale Refeição</option>
              <option value="12">Vale Presente</option>
              <option value="13">Vale Combustível</option>
              <option value="14">Duplicata Mercantil</option>
              <option value="15">Boleto bancário</option>
              <option value="99">Outros</option>
            </select>
          </div>
          <div class="form col-md-6">
            <label>Taxa (%)</label>
            <input type="number" class="form-control" placeholder="" step="any" v-model="formaPagamento.taxa">
          </div>
          <button class="btn btn-info ml-3 mr-10" :class="{ disabled : loading }">{{ formaPagamento.codigo ? 'Salvar': 'Cadastrar'}}</button>
          <button class="btn btn-secondary ml-3 mr-10">Limpar</button>
        </div>
      </form>
    </div>

    <div v-show="!cadastro" class="card-body">
      <h4 class="card-title">Formas de Pagamento</h4>
      <button class="btn btn-info" @click="exibirCadastro" v-if="cadastroWeb">Nova Forma de Pagamento</button>
      <div class="row pt-10">
        <div class="form-group col-md-12 hidden-mobile">
          <table id="listaformaspagamentos" class="display responsive nowrap table table-hover table-striped table-bordered" cellspacing="0" width="100%">
            <thead>
              <tr>
                <th>Forma de Pagamento</th>
                <th>Taxa</th>
                <th data-hide="phone" v-if="cadastroWeb">Ações</th>
              </tr> 
            </thead>
            <tbody>
              <tr v-for="(item, index) in fPagamentos" :key="index">
                <td>{{ item.descricao }}</td>
                <td>{{ item.taxa }}</td>
                <td v-if="cadastroWeb">
                  <button class="btn btn-sm btn-info px-2 py-1" @click="abrirFormaPagamento(item)"><i class="fa fa-pencil"></i></button>
                  <button class="btn btn-sm btn-danger px-2 py-1" style="margin-left:15px" @click="excluirCadastro(item)"><i class="fa fa-close"></i></button>
                </td>
              </tr>
              </tbody>
          </table>
        </div>
        
        <div class="mb-6" style="padding-left: 30px">
          <div v-for="(item, index) in fPagamentos" :key="index" class="row py-2 px-2 bordered-block-table only-mobile">
            <div class="col-6">
              <strong>{{ item.descricao }}</strong>
            </div>
            <div class="col-6" align="right">
              <strong>Taxa</strong>
              <span style="color: #888; font-size: 10px;"> {{ item.taxa }}%</span>
              <br>
              <button class="btn btn-sm btn-info px-2 py-1" @click="abrirFormaPagamento(item)" align="right" style="font-size: 10px;"><i class="fa fa-pencil"></i></button>
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import {
    Card,
    AnimatedNumber,
  } from 'src/components'
import { setInterval } from 'timers';
import {Table, TableColumn} from 'element-ui'
import moment from 'moment'
import GlobalFunctions from '../../../globalFunctions.js'
import FormaPgService from '../../../services/FormaPagamentoService.js'
import ErrorService from '@/services/ErrorService.js'

import { log } from 'util';
export default {
    components: {
      Card,
      AnimatedNumber,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      moment
    },
    data() {
      return {
        dataInicio: moment().format("YYYY-MM-DD"),
        dataFim: moment().format("YYYY-MM-DD"),
        dataFinalCabecalho:moment().format("DD/MM/YYYY"),
        dataInicioCabecalho:moment().format("DD/MM/YYYY"),
        mobile:GlobalFunctions.isMobile(), 
        cadastro: false,
        fPagamentos: [],
        formaPagamento: ({"tipo_nfce":1}),
        loading: false,
        cadastroWeb: localStorage.getItem('config_modulo_cadastro_web') == "true" ? true : false,
      }
    },
    methods:{
      load(){
        FormaPgService.load().then(res=>{
          this.fPagamentos = res.data;
        })
      },
      update(formaPagamento){ 
        if(formaPagamento.codigo){
          FormaPgService.update(formaPagamento).then(res=>{
           this.load()
           this.cadastro = false;  
           this.$swal('Forma de Pagameneto atualizada com sucesso!','', 'success')
          })
        }else{
          FormaPgService.create(formaPagamento).then(res => {
            this.load()
            this.cadastro = false;
            this.$swal('Forma de Pagamento cadastrada com sucesso!','', 'success')
          }).catch(e => {
            ErrorService.getMessage(e.response)
          // this.$swal('Erro ao cadastrar', e,'error')
          })
        }
      },
      excluirCadastro(item){
        FormaPgService.destroy(item.codigo).then(res => {
          this.$swal('Forma de Pagamento desativada com sucesso!','', 'success')
          this.load()
          this.cadastro = false;
        })
        .catch(e => {
            ErrorService.getMessage(e.response)
        })
      },
      abrirFormaPagamento(item){
        this.formaPagamento = item;
        this.cadastro = true;
      },
      exibirLista(){
        this.load()
        this.cadastro = false;
      },
      exibirCadastro(){
        this.formaPagamento = ({});
        this.cadastro = true;
      }
    },
    mounted(){
      this.load()
    }
}
</script>
